// Custom Messages

export const ruCustomMessages = {
    "pages": {
        "login": {
            "sighInTitle": "Войти в SINETOS",
            "username": "Имя пользователя",
            "email": "Электронная почта",
            "password": "Пароль",
            "rememberMe": "Запомнить меня",
            "welcome": "Добро пожаловать",
            "login": "Войти"
        },
        "welcome": {
            "home": "Главная",
            "features": "Функции",
            "events": "События",
            "pricing": "Цены",
            "title": "Найдите недвижимость в Греции и на Кипре",
            "login": "Войти",
            "logout": "Выйти",
            "dashboard": "Панель управления"
        },
        "emailAccount": {
            "createUser": "Отправить письмо на",
            "sendTestEmailToTitle": "Отправьте тестовое письмо, чтобы убедиться, что всё настроено правильно."
        },
        "portfolio": {
            "upload": "Загрузить",
            "download": "Скачать",
            "approval": "Одобрение",
            "emailInfo": "Информация об электронной почте",
            "restrictions": {
                "maxFileSize": "Ограничение размера документа < 2.097.152 КБ"
            }
        }
    },
    "common": {
        "cancel": "Отмена",
        "employee": "Сотрудник",
        "user": "Пользователь",
        "confirmation": "Подтверждение",
        "delete": "Удалить",
        "settings": "Настройки",
        "actions": "Действия",
        "languages": "Языки",
        "logout": "Выйти",
        "importResources": "Ресурсы вставки",
        "execute": "Выполнить",
        "clearAll": "Очистить записи",
        "mark": "Отметить"
    },
    "messages": {
        "deleteFile": "Удалить файл",
        "sendingEmail": "Отправка письма",
        "createNewUser": "Создать нового пользователя.",
        "clearAllCompleted": "Очистка записей завершена.",
        "emailSendingSuccessfullyCompleted": "Отправка письма успешно завершена.",
        "editSuccessfullyCompleted": "Изменения успешно сохранены.",
        "uploadSuccessfullyCompleted": "Загрузка успешно завершена.",
        "deleteFileSuccessfullyCompleted": "Удаление файла успешно завершено."
    }
};

// Kendo Angular Component Messages
export const ruComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty": "Перетащите заголовок столбца сюда, чтобы сгруппировать по этому столбцу.",
    "kendo.grid.noRecords": "Записи отсутствуют.",
    "kendo.grid.pagerFirstPage": "Перейти на первую страницу.",
    "kendo.grid.pagerPreviousPage": "Перейти на предыдущую страницу.",
    "kendo.grid.pagerNextPage": "Перейти на следующую страницу.",
    "kendo.grid.pagerLastPage": "Перейти на последнюю страницу.",
    "kendo.grid.pagerPage": "Страница",
    "kendo.grid.pagerOf": "из",
    "kendo.grid.pagerItems": "элементы",
    "kendo.grid.pagerItemsPerPage": "элементов на страницу",
    "kendo.grid.pagerPageNumberInputTitle": "Номер страницы",
    "kendo.grid.filter": "Фильтр",
    "kendo.grid.filterEqOperator": "Равно",
    "kendo.grid.filterNotEqOperator": "Не равно",
    "kendo.grid.filterIsNullOperator": "Пусто",
    "kendo.grid.filterIsNotNullOperator": "Не пусто",
    "kendo.grid.filterIsEmptyOperator": "Пустой",
    "kendo.grid.filterIsNotEmptyOperator": "Не пустой",
    "kendo.grid.filterStartsWithOperator": "Начинается с",
    "kendo.grid.filterContainsOperator": "Содержит",
    "kendo.grid.filterNotContainsOperator": "Не содержит",
    "kendo.grid.filterEndsWithOperator": "Заканчивается на",
    "kendo.grid.filterGteOperator": "Больше или равно",
    "kendo.grid.filterGtOperator": "Больше",
    "kendo.grid.filterLteOperator": "Меньше или равно",
    "kendo.grid.filterLtOperator": "Меньше",
    "kendo.grid.filterIsTrue": "истина",
    "kendo.grid.filterIsFalse": "ложь",
    "kendo.grid.filterBooleanAll": "(Все)",
    "kendo.grid.filterAfterOrEqualOperator": "После или равно",
    "kendo.grid.filterAfterOperator": "После",
    "kendo.grid.filterBeforeOperator": "До",
    "kendo.grid.filterBeforeOrEqualOperator": "До или равно",
    "kendo.grid.filterFilterButton": "Применить фильтр",
    "kendo.grid.filterClearButton": "Очистить",
    "kendo.grid.filterAndLogic": "И",
    "kendo.grid.filterOrLogic": "Или",
    "kendo.grid.filterDateToggle": "Переключить календарь",
    "kendo.grid.filterDateToday": "Сегодня",
    "kendo.grid.filterNumericDecrement": "Уменьшить значение",
    "kendo.grid.filterNumericIncrement": "Увеличить значение",
    "kendo.grid.loading": "Загрузка",
    "kendo.grid.columns": "Столбцы",
    "kendo.grid.lock": "Заблокировать",
    "kendo.grid.unlock": "Разблокировать",
    "kendo.grid.stick": "Закрепить",
    "kendo.grid.unstick": "Открепить",
    "kendo.grid.setColumnPosition": "Установить позицию столбца",
    "kendo.grid.sortAscending": "Сортировать по возрастанию",
    "kendo.grid.sortDescending": "Сортировать по убыванию",
    "kendo.grid.columnsApply": "Применить",
    "kendo.grid.columnsReset": "Сбросить",
    "kendo.grid.sortable": "Сортируемый",
    "kendo.grid.sortedAscending": "Отсортировано по возрастанию",
    "kendo.grid.sortedDescending": "Отсортировано по убыванию",
    "kendo.grid.sortedDefault": "Без сортировки",
    "kendo.grid.filterInputLabel": "Фильтр {columnName}",
    "kendo.grid.filterMenuTitle": "Меню фильтра {columnName}",
    "kendo.grid.filterMenuOperatorsDropDownLabel": "Операторы фильтра {columnName}",
    "kendo.grid.filterMenuLogicDropDownLabel": "Логика фильтра {columnName}",
    "kendo.grid.columnMenu": "Меню столбца {columnName}",
    "kendo.grid.selectionCheckboxLabel": "Выбрать строку",
    "kendo.grid.selectAllCheckboxLabel": "Выбрать все строки",
    "kendo.grid.pagerLabel": "Навигация по страницам, страница {currentPage} из {totalPages}",
    "kendo.grid.gridLabel": "Таблица данных",
    "kendo.grid.groupCollapse": "Свернуть группу",
    "kendo.grid.groupExpand": "Развернуть группу",
    "kendo.grid.detailCollapse": "Свернуть детали",
    "kendo.grid.detailExpand": "Развернуть детали",
    "kendo.grid.autosizeThisColumn": "Авторазмер для этого столбца",
    "kendo.grid.autosizeAllColumns": "Авторазмер для всех столбцов",
    "kendo.grid.pagerSelectPage": "Выбрать страницу",
    "kendo.grid.topToolbarLabel": "Верхняя панель инструментов",
    "kendo.grid.bottomToolbarLabel": "Нижняя панель инструментов",
    "kendo.grid.groupPanelLabel": "Панель группировки",
    "kendo.grid.dragRowHandleLabel": "Перетащить строку",
    "kendo.grid.selectRowCheckboxLabel": "Выбрать строку",
    "kendo.grid.selectAllRowsCheckboxLabel": "Выбрать все строки",
    "kendo.grid.filterCellOperatorLabel": "Операторы фильтра для {columnName}",
    "kendo.grid.booleanFilterCellLabel": "Булев фильтр для {columnName}",
    "kendo.grid.columnMenuFilterTabTitle": "Фильтр",
    "kendo.grid.columnMenuGeneralTabTitle": "Общие",
    "kendo.grid.columnMenuColumnsTabTitle": "Столбцы",
    "kendo.grid.groupChipMenuPrevious": "Переместить как предыдущий",
    "kendo.grid.groupChipMenuNext": "Переместить как следующий",
    "kendo.grid.pagerInputLabel": "Введите номер страницы",

    // Filter
    "kendo.filter.addExpression": "Добавить выражение",
    "kendo.filter.addFilter": "Добавить фильтр",
    "kendo.filter.addGroup": "Добавить группу",
    "kendo.filter.remove": "Удалить",
    "kendo.filter.editorDateTodayText": "Сегодня",
    "kendo.filter.editorDateToggleText": "Переключить календарь",
    "kendo.filter.editorNumericDecrement": "Уменьшить",
    "kendo.filter.editorNumericIncrement": "Увеличить",
    "kendo.filter.filterAfterOperator": "Позже чем",
    "kendo.filter.filterAfterOrEqualOperator": "Позже или равно",
    "kendo.filter.filterAndLogic": "И",
    "kendo.filter.filterBeforeOperator": "Раньше чем",
    "kendo.filter.filterBeforeOrEqualOperator": "Раньше или равно",
    "kendo.filter.filterBooleanAll": "(Все)",
    "kendo.filter.filterContainsOperator": "Содержит",
    "kendo.filter.filterEndsWithOperator": "Заканчивается на",
    "kendo.filter.filterEqOperator": "Равно",
    "kendo.filter.filterExpressionFilters": "Фильтры",
    "kendo.filter.filterExpressionOperators": "Операторы",
    "kendo.filter.filterGtOperator": "Больше чем",
    "kendo.filter.filterGteOperator": "Больше или равно",
    "kendo.filter.filterIsEmptyOperator": "Пусто",
    "kendo.filter.filterIsFalse": "Ложь",
    "kendo.filter.filterIsTrue": "Истина",
    "kendo.filter.filterIsNotEmptyOperator": "Не пусто",
    "kendo.filter.filterIsNotNullOperator": "Не ноль",
    "kendo.filter.filterIsNullOperator": "Ноль",
    "kendo.filter.filterLtOperator": "Меньше чем",
    "kendo.filter.filterLteOperator": "Меньше или равно",
    "kendo.filter.filterNotContainsOperator": "Не содержит",
    "kendo.filter.filterNotEqOperator": "Не равно",
    "kendo.filter.filterOrLogic": "Или",
    "kendo.filter.filterStartsWithOperator": "Начинается с",
    "kendo.filter.filterFieldAriaLabel": "Поле",
    "kendo.filter.filterOperatorAriaLabel": "Оператор",
    "kendo.filter.filterValueAriaLabel": "Значение",
    "kendo.filter.filterAriaLabel": "Фильтр",
    "kendo.filter.filterToolbarAriaLabel": "Настройки фильтра",

    // DropDowns
    'kendo.autocomplete.noDataText': 'No data found',
    'kendo.autocomplete.clearTitle': 'Clear',
    'kendo.combobox.noDataText': 'No data found',
    'kendo.combobox.clearTitle': 'Clear',
    'kendo.dropdownlist.noDataText': 'No data found',
    'kendo.dropdownlist.clearTitle': 'Clear',

    // Calendar
    'kendo.calendar.today': 'TODAY',

    // TextBox
    'kendo.textbox.clearTitle': 'Clear',

    // DatePicker
    'kendo.datepicker.today': 'TODAY',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Increase value',
    'kendo.dateinput.decrement': 'Decrease value',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Increase value',
    'kendo.numerictextbox.decrement': 'Decrease value',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Date tab',
    'kendo.datetimepicker.timeTab': 'Time',
    'kendo.datetimepicker.timeTabLabel': 'Time tab',
    'kendo.datetimepicker.toggle': 'Toggle popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Cancel',
    'kendo.datetimepicker.cancelLabel': 'Cancel',
    'kendo.datetimepicker.now': 'NOW',
    'kendo.datetimepicker.nowLabel': 'Select now',
    'kendo.datetimepicker.today': 'TODAY',
    'kendo.datetimepicker.prevButtonTitle': 'Navigate to previous view',
    'kendo.datetimepicker.nextButtonTitle': 'Navigate to next view',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Cancel',
    'kendo.timepicker.cancelLabel': 'Cancel',
    'kendo.timepicker.now': 'Now',
    'kendo.timepicker.nowLabel': 'Now',
    'kendo.timepicker.toggle': 'Toggle time list',

    // FileSelect
    'kendo.fileselect.cancel': 'Cancel',
    'kendo.fileselect.clearSelectedFiles': 'Clear',
    'kendo.fileselect.dropFilesHere': 'Drop files here to upload',
    'kendo.fileselect.externalDropFilesHere': 'Drag and drop files here to upload',
    'kendo.fileselect.filesBatchStatus': 'files',
    'kendo.fileselect.filesBatchStatusFailed': 'files failed to upload.',
    'kendo.fileselect.filesBatchStatusUploaded': 'files successfully uploaded.',
    'kendo.fileselect.fileStatusFailed': 'File failed to upload.',
    'kendo.fileselect.fileStatusUploaded': 'File successfully uploaded.',
    'kendo.fileselect.headerStatusPaused': 'Paused',
    'kendo.fileselect.headerStatusUploaded': 'Done',
    'kendo.fileselect.headerStatusUploading': 'Uploading...',
    'kendo.fileselect.invalidFileExtension': 'File type not allowed.',
    'kendo.fileselect.invalidMaxFileSize': 'File size too large.',
    'kendo.fileselect.invalidMinFileSize': 'File size too small.',
    'kendo.fileselect.remove': 'Remove',
    'kendo.fileselect.retry': 'Retry',
    'kendo.fileselect.select': 'Select files...',
    'kendo.fileselect.uploadSelectedFiles': 'Upload files',

    // Scheduler
    "kendo.scheduler.agendaViewTitle": "Agenda",
    "kendo.scheduler.allDay": "all day",
    "kendo.scheduler.allEvents": "All events",
    "kendo.scheduler.calendarToday": "TODAY",
    "kendo.scheduler.cancel": "Cancel",
    "kendo.scheduler.save": "Save",
    "kendo.scheduler.editorEventTitle": "Title",
    "kendo.scheduler.editorEventStart": "Start",
    "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
    "kendo.scheduler.editorEventEnd": "End",
    "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
    "kendo.scheduler.dateHeader": "Date",
    "kendo.scheduler.dayViewTitle": "Day",
    "kendo.scheduler.deleteConfirmation": "Are you sure you want to delete this event?",
    "kendo.scheduler.deleteDialogTitle": "Delete Event",
    "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
    "kendo.scheduler.deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
    "kendo.scheduler.deleteSeries": "Delete the series",
    "kendo.scheduler.deleteTitle": "Delete",
    "kendo.scheduler.destroy": "Delete",
    "kendo.scheduler.editOccurrence": "Edit current occurrence",
    "kendo.scheduler.editorEventAllDay": "All Day Event",
    "kendo.scheduler.editorEventDescription": "Description",
    "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
    "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
    "kendo.scheduler.editorTitle": "Event",
    "kendo.scheduler.editRecurringConfirmation": "Do you want to edit only this event occurrence or the whole series?",
    "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
    "kendo.scheduler.editSeries": "Edit the series",
    "kendo.scheduler.eventHeader": "Event",
    "kendo.scheduler.monthViewTitle": "Month",
    "kendo.scheduler.multiDayViewTitle": "Multi-Day",
    "kendo.scheduler.nextTitle": "Next",
    "kendo.scheduler.previousTitle": "Previous",
    "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorEndAfter": "After",
    "kendo.scheduler.recurrenceEditorEndLabel": "End",
    "kendo.scheduler.recurrenceEditorEndNever": "Never",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
    "kendo.scheduler.recurrenceEditorEndOn": "On",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
    "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
    "kendo.scheduler.recurrenceEditorYearlyOf": "of",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
    "kendo.scheduler.showFullDay": "Show full day",
    "kendo.scheduler.showWorkDay": "Show business hours",
    "kendo.scheduler.timeHeader": "Time",
    "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
    "kendo.scheduler.timelineViewTitle": "Timeline",
    "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
    "kendo.scheduler.today": "Today",
    "kendo.scheduler.weekViewTitle": "Week",
    "kendo.scheduler.workWeekViewTitle": "Work Week",

    // RecurrenceEditor
    "kendo.recurrenceeditor.dailyInterval": "day(s)",
    "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.endAfter": "After",
    "kendo.recurrenceeditor.endLabel": "End",
    "kendo.recurrenceeditor.endNever": "Never",
    "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
    "kendo.recurrenceeditor.endOn": "On",
    "kendo.recurrenceeditor.frequenciesDaily": "Daily",
    "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
    "kendo.recurrenceeditor.frequenciesNever": "Never",
    "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
    "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
    "kendo.recurrenceeditor.monthlyDay": "Day",
    "kendo.recurrenceeditor.monthlyInterval": "month(s)",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
    "kendo.recurrenceeditor.offsetPositionsLast": "Last",
    "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
    "kendo.recurrenceeditor.offsetPositionsThird": "Third",
    "kendo.recurrenceeditor.repeat": "Repeat",
    "kendo.recurrenceeditor.weekdaysDay": "Day",
    "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
    "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
    "kendo.recurrenceeditor.weeklyInterval": "week(s)",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
    "kendo.recurrenceeditor.yearlyInterval": "year(s)",
    "kendo.recurrenceeditor.yearlyOf": "of",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
